// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2024 (original work) Open Assessment Technologies SA ;
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License

import config from '@/config';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

export const routing = [
    {
        path: [config.routes.sessionTemplates.list],
        guard: getPermissionsGuard([{ resource: 'portal.session-template', scopes: ['view'] }]),
        controller: () => import('./controllers/sessionTemplates')
    },
    {
        path: [config.routes.sessionTemplates.edit],
        guard: getPermissionsGuard([{ resource: 'portal.session-template', scopes: ['edit'] }]),
        controller: () => import('./controllers/sessionTemplate')
    },
    {
        path: [config.routes.sessionTemplates.create],
        guard: getPermissionsGuard([{ resource: 'portal.session-template', scopes: ['create'] }]),
        controller: () => import('./controllers/sessionTemplate')
    }
];
